import { useEffect, useState} from "react";
import {useNavigate, useOutletContext, useSearchParams} from "react-router-dom";
import venifyLogo from "../../venifyLogo.png"
import Api from "../../tools/service";
import Container from "../../components/Container";

import LoadingScreen from "../../components/LoadingScreen";
import {MdAlternateEmail} from "react-icons/md";
import {TbWorldWww} from "react-icons/tb";
import {AuthenticationDefaultSteps} from "../../tools/defaults/authentication/Authentication";
import WidgetRules from "./WidgetRules";

const IAuthReports=()=>{
    const [token,setToken] = useOutletContext();

    const [info,setInfo]=useState(null);
    const [loading,setLoading]=useState(true)
    const [AuthDate,setAuthDate]=useState()
    const [searchParams] = useSearchParams();
    const ref=searchParams.get('ref');

    const navigate=useNavigate();
/*    useEffect(()=>{

        if(token){
            getReports()
        }
    },[token]);*/
    useEffect(() => {
        getReports()
    }, []);
    const getReports=()=>{

        setLoading(true)
        Api.get(`api/v1/Public/OriginalityDevice/${ref}`,{
            params:{
                g_response:token,
            }
        }).then(response=>{

            if(!response.hasError){

                setInfo(response.data)

                const date = new Date(response.data.auth_date * 1000);
                const formatter = new Intl.DateTimeFormat('fa-IR', {
                    month:"long",
                    day:"numeric",
                    calendar:"persian",
                    year:"numeric"
                });
                setAuthDate(formatter.format(date))
            }else{
                navigate('/notfound')
            }
        }).catch(e=>{

        }).finally(()=>{
            setLoading(false)
        })
    }
    if(loading){
        return  <LoadingScreen/>
    }





    return <div className="  ">

        <Container className="flex  font-sm rtl mt-5 lg:mt-16 items-center flex-col justify-center">
            <div dir="rtl" className="w-full  ">
                <div className=" items-center w-full mb-2 rounded-xl  flex bg-white p-5  ">
                    <a className="w-16" href="https://venify.ir">
                        <img className="w-16" src={venifyLogo} alt=""/>
                    </a>
                    <div className="flex mr-2 flex-col">
                        <a href="https://venify.ir">
                            <h1 className="text-xl    font-bold  ">ونیفای</h1>
                        </a>
                        <p className="  text-sm  "> ارائه دهنده سرویس‌های هوشمند مالی و بانکی در
                            جهت
                            سهولت و مجازی‌سازی خدمات</p>
                    </div>


                </div>
            </div>
            <div className="grid grid-cols-1 gap-2 lg:grid-cols-6">
                {info && <div className="w-full p-5  bg-white rounded-xl col-span-2">
                    <div className="w-full flex flex-col h-full  justify-between">
                        <div className="w-full">
                            <h1 className="text-start mb-2 pb-2 border-b  items-center  font-bold text-xl">{info?.title}</h1>
                            <div className="w-full border-b flex flex-col">
                                <div className=" grid p-2 gap-2 grid-cols-2">
                                    <span>برند</span>
                                    <span className="font-semibold text-left">{info.widget_body.brand}</span>
                                </div>
                            </div>
                            <div className="w-full flex border-b flex-col">
                                <div className=" grid gap-2 p-2   grid-cols-2">
                                    <span>مدل</span>
                                    <span className="font-semibold text-left">{info.widget_body.model}</span>
                                </div>
                            </div>
                        </div>
                        <div className="flex items-center  flex-col    pt-3 mt-3  ">
                            <div
                                className=" mb-2 mt-4   w-full  text-sm  rounded-lg  flex justify-between items-center  ">
                                <span>تاریخ استعلام  </span>
                                <span className="font-semibold ">{AuthDate}</span>
                            </div>
                            {info.btns.map((btn, index) => {
                                return <a href={btn.url} className="w-full " key={index}>
                                    <button className="p-3 btn btn-green w-full  text-sm   px-5 rounded-lg  ">
                                        {btn.title}
                                    </button>
                                </a>
                            })}
                        </div>
                    </div>

                </div>}
                <WidgetRules/>
            </div>

            <div dir="rtl"
                 className="w-full    mt-4 text-sm      text-center flex justify-center items-center flex-col ">
                <div className="grid grid-cols-2 lg:grid-cols-2  w-full   gap-3 ">
                    <div className=" p-5 col-span-1 bg-white flex justify-start items-center text-gray-800 rounded-xl">
                        <TbWorldWww className="text-xl"/>
                        <div className="flex  mr-3 flex-col items-start justify-start">
                            <p className="text-gray-800 mb-1">آدرس وبسایت</p>
                            <a href="https://venify.ir" className="text-gray-800 font-bold">https://venify.ir</a>
                        </div>
                    </div>
                    <div className=" p-5 col-span-1 bg-white flex justify-start  items-center text-gray-800 rounded-xl">
                        <MdAlternateEmail className="text-xl"/>
                        <div className="flex mr-3 flex-col items-start justify-start">

                            <p className="text-gray-700 text-sm mb-1">ایمیل</p>
                            <a href="mailto:info@venify.ir" className=" font-bold">info@venify.ir</a>
                        </div>
                    </div>
                </div>
                <div className="w-full border-t mt-5 "></div>
                <p className="mt-2 text-sm ">تمامی حقوق مربوط به این وب‌سایت، متعلق به شرکت <a
                    className="text-red-600 font-bold" href="https://asredade.com">عصرداده</a> می باشد.</p>
            </div>
        </Container>


    </div>
}
export default IAuthReports;